module.exports = __webpack_public_path__ + "static/media/  (164).3648087f.jpg";